import React from "react";
import PropTypes from "prop-types";
import { LuSearchX } from "react-icons/lu";
import "./_emptyState.scss";

// Friendly placeholder shown when a search returns nothing.
const EmptyState = ({ title, hint }) => (
  <div className="cmp-empty">
    <div className="cmp-empty__icon">
      <LuSearchX size={22} />
    </div>
    <div className="cmp-empty__title">{title}</div>
    {hint ? <div className="cmp-empty__hint">{hint}</div> : null}
  </div>
);

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  hint: PropTypes.string,
};

export default EmptyState;
